import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function safeExternalHref(url) {
  if (!url || typeof url !== "string") return null;
  const trimmed = url.trim();
  // Block javascript:, data:, vb.
  if (!/^https?:\/\//i.test(trimmed)) return null;
  return trimmed;
}
